module.exports = "<app-layout *ngIf=\"showHeader\"></app-layout>\r\n<router-outlet></router-outlet>\r\n"